import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  class: "btn btn-secondary btn-sm dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "false",
  "aria-expanded": "false"
}
const _hoisted_3 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_burst_item = _resolveComponent("burst-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      _createVNode(_component_vue_feather, { type: "shopping-bag" }),
      _createTextVNode(" " + _toDisplayString(_ctx.selectedPages.length), 1)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          class: "dropdown-item red",
          onClick: _cache[0] || (_cache[0] = 
            async () => {
              _ctx.removeAllBursts();
            }
          )
        }, " Remove Selection ")
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPages, (burst) => {
        return (_openBlock(), _createElementBlock("li", { key: burst }, [
          _createVNode(_component_burst_item, { burst: burst }, {
            buttons: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn btn-sm btn-danger",
                onClick: 
                async () => {
                  _ctx.removeBurst(burst);
                }
              
              }, [
                _createVNode(_component_vue_feather, { type: "trash" })
              ], 8, _hoisted_4)
            ]),
            _: 2
          }, 1032, ["burst"])
        ]))
      }), 128))
    ])
  ]))
}